import { render, staticRenderFns } from "./commonTable.vue?vue&type=template&id=01289ea0"
import script from "./commonTable.vue?vue&type=script&lang=js"
export * from "./commonTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01289ea0')) {
      api.createRecord('01289ea0', component.options)
    } else {
      api.reload('01289ea0', component.options)
    }
    module.hot.accept("./commonTable.vue?vue&type=template&id=01289ea0", function () {
      api.rerender('01289ea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Protein/rmcDrugDosage/commonTable.vue"
export default component.exports